import "./App.css";
import React, { Suspense, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AnimeDisplay from "./AnimeDisplay/pages/AnimeDisplay";
import { useAuth } from "./hooks/auth-hook";
import { AuthContext } from "./shared/context/auth-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = React.lazy(() => import("./Home/pages/Home"));
const Animes = React.lazy(() => import("./Animes/pages/Animes"));
const Auth = React.lazy(() => import("./Auth/pages/Auth"));
const Header = React.lazy(() => import("./Header/pages/Header"));
const Profile = React.lazy(() => import("./User/pages/Profile"));
const PageNotFound = React.lazy(() =>
  import("./shared/components/PageNotFound")
);

function App() {
  const { userId, username, token, image, login, logout } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [authPage, setAuthPage] = useState("login");

  const openAuth = () => {
    setShowAuth((prev) => !prev);
  };

  const changeAuthPage = (page) => {
    setAuthPage(page);
  };

  return (
    <React.StrictMode>
      <AuthContext.Provider
        value={{
          isLoggedIn: !!token,
          token: token,
          userId: userId,
          username: username,
          image: image,
          login,
          logout,
        }}
      >
        <div className="relative text-white ">
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Router>
            <Auth
              showAuth={showAuth}
              openAuth={openAuth}
              authPage={authPage}
              changeAuthPage={changeAuthPage}
            />
          </Router>
          <Router>
            <Suspense fallback={<div>Loading...</div>}>
              <Header showAuth={showAuth} openAuth={openAuth} />
              <div className="relative md:mx-md mx-sm text-white ">
                <Routes>
                  <Route
                    path="/"
                    exact
                    element={<Home openAuth={openAuth} />}
                  />
                  <Route
                    path="/animes"
                    element={<Animes openAuth={openAuth} />}
                  />
                  <Route
                    path="/anime/:id"
                    element={<AnimeDisplay openAuth={openAuth} />}
                  />
                  {token && (
                    <Route
                      path="/user/:id"
                      element={<Profile openAuth={openAuth} />}
                    />
                  )}

                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </div>
            </Suspense>
          </Router>
        </div>
      </AuthContext.Provider>
    </React.StrictMode>
  );
}

export default App;
